import { createFileRoute } from '@tanstack/react-router';

import { SiteResultsPage } from '@/features/owner/site/SiteResultsPage';

export const Route = createFileRoute('/_authed/owner/site/results')({
  component: SiteResultsPage,
});
